import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  gap: ${theme.spacing.xm};
`

export const AlertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`

export const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${theme.spacing.xm};
`

export const TitleRow = styled.div`
  display: flex;
  gap: ${theme.spacing.md};
  align-items: center;
`

export const IconTitleRow = styled(TitleRow)`
  gap: 8px;

  h1 {
    color: ${theme.colors.primary.main};
  }
`

export const Title = styled.h1`
  margin: 0;
  font-size: ${theme.typography.sizes.md};
  font-weight: ${theme.typography.family.bold};
  color: ${theme.colors.neutral.high};
`

export const ColDivider = styled.div`
  height: 20px;
  width: 1px;
  background-color: ${theme.colors.neutral.lighthover};
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.xm};
  gap: ${theme.spacing['2xm']};
  border-radius: ${theme.shapes.borderRadius.xm};
  box-shadow: ${theme.effects.boxShadow.card};
`

export const ButtonsRow = styled.div`
  display: flex;
  gap: 12px;
`

export const OfficeTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
  padding: ${theme.spacing.xm};
  border: 1px solid ${theme.colors.alert.info[20]};
  border-radius: ${theme.shapes.borderRadius.xm};

  p {
    color: ${theme.colors.primary.main} !important;
  }
`

export const OfficeTooltip = styled.div`
  display: flex;
  height: 30px;
  align-items: center;
  border-radius: 6px;
  padding: 0 ${theme.spacing.sm};
  background-color: ${theme.colors.alert.info.ligther};

  p.office-info {
    color: ${theme.colors.alert.info[40]} !important;
  }
`

export const RowDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${theme.colors.neutral.lighthover};
`

export const TableActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${theme.spacing.xm};
`

export const ActionButtons = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
`

export const ActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 ${theme.spacing.sm};
  border: 0;
  outline: none;
  background: transparent;
  height: ${theme.spacing.lg};
  transition: 0.2s ease-in-out;
  border-radius: ${theme.shapes.borderRadius.sm};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.white};
  gap: ${theme.spacing.xs};
`

export const ApproveButton = styled(ActionButton)`
  background: ${theme.colors.alert.success.dark};
  :hover {
    background: ${theme.colors.alert.success.darker};
  }
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const RejectButton = styled(ActionButton)`
  background: ${theme.colors.alert.danger.dark};
  :hover {
    background: ${theme.colors.alert.danger.darker};
  }
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

type ColoredTextProps = {
  color: string
}

export const ColoredText = styled.span<ColoredTextProps>`
  font-size: ${theme.typography.sizes.xs};
  font-family: ${theme.typography.family.bold};
  color: ${({ color }) => color};
`

export const ModalActions = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing.xm};
`

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 490px;
  width: 100%;
`

export const ValueRow = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
  align-items: center;
`

export const ValueDivider = styled.div`
  width: 1px;
  height: 12px;
  background-color: ${theme.colors.neutral.mediumhover};
`
